import { render, staticRenderFns } from "./GooglePlus.vue?vue&type=template&id=74018e16&"
import script from "./GooglePlus.vue?vue&type=script&lang=js&"
export * from "./GooglePlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GooglePlus.vue"
export default component.exports